import {
  DeleteScheduledNotification,
  DeleteScheduledNotificationVariables
} from './__generated__/DeleteScheduledNotification'

import { gql } from 'apollo-boost'
import { useMutation } from '@apollo/react-hooks'

const MUTATION = gql`
  mutation DeleteScheduledNotification($input: DeleteScheduledNotificationInputV2!) {
    deleteScheduledNotificationV2(input: $input) {
      ... on ScheduledNotificationErrorV2 {
        type
        error
      }
      ... on ScheduledNotificationV2 {
        id
      }
    }
  }
`

export const useDeleteScheduledNotification = () =>
  useMutation<DeleteScheduledNotification, DeleteScheduledNotificationVariables>(MUTATION)
